import { render, staticRenderFns } from "./face_webrtc.vue?vue&type=template&id=4a727ad4&scoped=true"
import script from "./face_webrtc.vue?vue&type=script&lang=js"
export * from "./face_webrtc.vue?vue&type=script&lang=js"
import style0 from "./face_webrtc.vue?vue&type=style&index=0&id=4a727ad4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a727ad4",
  null
  
)

export default component.exports